import { Host } from "../../commonInterfaces.js";
import { Saveable } from "./commonApp.js";
import { InfoItemRefresher } from "./editableGrid/editableGrid.js";
import IndividualNDataInline from "./individualNDataInline.js";
import React from "react";
export default class IndividualNDataInlineSaveable implements Saveable {
    private host: Host;
    private hasChanges;
    private infoRefresher: InfoItemRefresher;
    private individualDataGrid: IndividualNDataInline;

    constructor(host: Host) {
        this.host = host;
    }

    GetMenuItem(onClick): any {
        return null;
        //return <InfoItemRefresher ref={(e) => this.infoRefresher = e} numberItems={null} />;
    }

    HasChanges(): boolean {
        return this.hasChanges;
    }

    private handleChange = () => {
        this.hasChanges = true;
        if (this.host) {
            this.host.notifyChange();
        }
    }

    Save() {
        if (this.individualDataGrid && this.individualDataGrid.canSave()) {
            this.individualDataGrid.save()
            this.hasChanges = false;
        }
    }

    GetComponent(keyVal1: string, keyVal2: string, props: { type: string }, recordRight: any): any {
        return <IndividualNDataInline
            ref={(e) => this.individualDataGrid = e}
            type={props.type}
            onChange={this.handleChange}
            keyVal1={keyVal1}
            keyVal2={keyVal2}
            recordRight={recordRight}
            getMenuItemReference={() => { return this.infoRefresher }} />;
    }
}